import { render, staticRenderFns } from "./ConfirmSimple.vue?vue&type=template&id=5253c610"
import script from "./ConfirmSimple.vue?vue&type=script&lang=ts"
export * from "./ConfirmSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports